import React, { useEffect } from 'react';
import ReactGA from "react-ga4";
import PageTopBanner from "../components/PageTopBanner";
import { contentData } from '../data/contentData';
import '../style/pages/_certificationQualiopi.scss';

const CertificationQualiopi = () => {
    useEffect(() => {
        ReactGA.send({
            hitType: "pageview",
            page: "/certification-qualiopi",
            title: "Certification Qualiopi",
        });
    });

    const selectedContent = contentData.find((content) => content.id === 1);
    return (
        <div>
            <main>
                <PageTopBanner
                    img={selectedContent.img}
                    title={selectedContent.title}
                    info={selectedContent.info}
                />

                <div className="o3academie-container">
                    <div className="container">
                        <section className="qualiopi-description">
                            <h2>Qu’est-ce que la certification Qualiopi ?</h2>
                            <p>
                                La certification Qualiopi garantit que le processus de formation respecte des critères exigeants en matière de conception, de suivi et d’accompagnement des apprenants.
                            </p>

                            <p>Une certification Qualiopi est un gage de sérieux et de qualité. Elle permet d’assurer :
                                <ul>
                                    <li>La délivrance de programmes pédagogiques clairs et adaptés aux besoins des apprenants ;</li>
                                    <li>La mise à disposition de formateurs compétents et expérimentés ;</li>
                                    <li>Un accompagnement personnalisé pour favoriser la réussite de chacun ;</li>
                                    <li>Une démarche d’amélioration continue pour garantir une qualité optimale.</li>
                                </ul>
                            </p>

                            <div className="qualiopi-container">
                                <img className="qualiopi-logo" src="../../assets/img/logo-qualiopi.jpg" alt="Certification Qualiopi" />
                                <p>La certification de qualité a été délivrée au titre des catégories d'action suivantes :
                                    <ul>
                                        <li>ACTIONS DE FORMATION</li>
                                        <li>ACTIONS DE FORMATION PAR APPRENTISSAGE</li>
                                    </ul>
                                    <a href="/Certificat_F3350.pdf" className="qualiopi-link" target="_blank" rel="noopener noreferrer">Voir le certificat</a>
                                </p>
                            </div>
                        </section>

                        <section className="benefits-description">
                            <h2>Quels avantages pour vous ?</h2>
                            <p>
                                Opter pour une formation certifiée Qualiopi avec O3 Académie, c’est bénéficier de nombreux avantages :
                                <ul>
                                    <li><strong>Accès facilité aux financements :</strong> en choisissant une formation éligible au CPF ou à d’autres dispositifs, vous optimisez vos possibilités de prise en charge financière.</li>
                                    <li><strong>Confiance et transparence :</strong> la certification Qualiopi vous assure une formation de qualité répondant à des standards exigeants.</li>
                                    <li><strong>Valorisation de votre parcours :</strong> une formation certifiée est un atout supplémentaire sur votre CV et aux yeux des employeurs.</li>
                                    <li><strong>Accompagnement sur mesure :</strong> chez O3 Académie, nous mettons un point d’honneur à adapter nos formations aux besoins spécifiques de chaque apprenant, notamment ceux nécessitant un soutien particulier.</li>
                                </ul>
                            </p>
                            <p>
                                En choisissant O3 Académie, vous investissez dans une formation de qualité, certifiée et conçue pour vous accompagner vers vos objectifs professionnels.
                            </p>
                        </section>
                    </div>

                </div>
            </main>
        </div>
    );
};

export default CertificationQualiopi;